function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import Paper from '../Paper';
import ListPaginator from '../ListPaginator';
import ListPerPageSelect from '../ListPerPageSelect';
import { styled } from '../styles';
import { isLayoutVariantCompact } from "../ListBase";
const PaperStyled = styled(Paper, {
  shouldForwardProp: prop => prop !== 'layoutVariant'
})(_ref => {
  let {
    compact = false,
    theme
  } = _ref;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(compact == false ? 1 : 0.5)
  };
});
export function ListFooter(_ref2) {
  let {
    layoutVariant = "standard",
    results,
    ListPaginatorProps,
    ListPerPageSelectProps,
    onChange = e => {}
  } = _ref2;
  const renderPerPageSelect = Array.isArray(ListPerPageSelectProps.perPageOptions) && ListPerPageSelectProps.perPageOptions.length;
  const compact = useMemo(() => isLayoutVariantCompact(layoutVariant), [layoutVariant]);
  return /*#__PURE__*/React.createElement(PaperStyled, {
    elevation: 2,
    compact: compact
  }, /*#__PURE__*/React.createElement(ListPaginator, _extends({
    results: results,
    onChange: onChange
  }, ListPaginatorProps)), renderPerPageSelect && /*#__PURE__*/React.createElement(ListPerPageSelect, ListPerPageSelectProps));
}
;
export default ListFooter;